/**
 * @file Checks for valid permissions in album folder for Web Galleries.
 */

import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';

import { WithAlbumFolderAccessControlHOC } from '../../../components/routing/discover/AlbumFolderAccessControl';
import { prependAccountSlug } from '../../../util/account';
import { AlbumFolderForWebGalleries } from '../graphql/queries/album-folder';

/**
 * Higher order container for the album folder access control functionality.
 *
 * @param {React.Component} WrappedComponent The component to be composed.
 * @returns {Function} The HOC container.
 */
const WebGalleryAlbumFolderAccessControl = WrappedComponent => {
  const WithAlbumFolderAccessControl = WithAlbumFolderAccessControlHOC(
    WrappedComponent,
    {
      requiresAuth: true,
      getRedirectUrl: ({ albumFolder }) =>
        prependAccountSlug(
          `/galleries/view/folder/${albumFolder.id}/request-access`,
          albumFolder,
        ),
    },
  );

  const withAlbumFolderData = graphql(AlbumFolderForWebGalleries, {
    options: ({ match }) => ({
      variables: {
        id: match.params.folderId,
      },
    }),
    props: ({ data: { albumFolder, loading } }) => ({
      albumFolder,
      loading,
    }),
  });

  const mapStateToProps = ({ auth }) => ({
    authenticated: auth.authenticated,
  });

  return compose(
    connect(mapStateToProps),
    withAlbumFolderData,
  )(WithAlbumFolderAccessControl);
};

export default WebGalleryAlbumFolderAccessControl;
